import React from 'react'

function schemeChart() {
  return (
    <div>schemeChart</div>
  )
}

export default schemeChart